import React from 'react';

import { Heading, VStack } from '@eluve/components';

import { TenantLogoSettings } from './TenantLogoSettings';
import { TenantNameSettings } from './TenantNameSettings';

export const GeneralTenantSettingsPage: React.FC = () => {
  return (
    <div className="container pb-8">
      <VStack className="py-8 sm:px-8" gap={8}>
        <Heading size="2xl">General</Heading>
        <TenantNameSettings />
        <TenantLogoSettings />
      </VStack>
    </div>
  );
};
